import React from 'react';
import { Layout, Grid, theme } from 'antd';
import { Outlet } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import AdminNavigation from '../navigation/AdminNavigationContainer';

const { Content } = Layout;
const { useBreakpoint } = Grid;

const AdminLayout: React.FC = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const { theme: themeContext } = useTheme();
  const isDarkMode = themeContext.algorithm?.[0] === theme.darkAlgorithm;

  const themeTokens = {
    background: isDarkMode ? '#141414' : '#f5f7fa',
    contentBackground: isDarkMode ? '#1f1f1f' : '#ffffff',
    textColor: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.85)',
    borderColor: isDarkMode ? '#303030' : '#f0f0f0'
  };

  const layoutStyles = {
    backgroundColor: themeTokens.background,
    minHeight: '100vh',
    height: '100%',
    display: 'flex',
    color: themeTokens.textColor,
    transition: 'all 0.3s ease-in-out'
  };

  const contentStyles = {
    marginLeft: isMobile ? 0 : 220,
    width: '100%',
    padding: isMobile ? '12px' : '24px',
    overflow: 'auto',
    minHeight: '100vh',
    background: themeTokens.background,
    transition: 'all 0.3s ease-in-out',
    color: themeTokens.textColor
  };

  return (
    <Layout style={layoutStyles}>
      <AdminNavigation/>
      <Layout style={contentStyles}>
        <Content>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
